import { Switch3Props } from '../../core'
import { FormHelperText } from '../../form'
import { styled } from '../../styles'

export const StyledHelperText = styled(FormHelperText)(({ theme, color }) => ({
  // Used in Radio3 and Checkbox3
  color: `${color === 'error' ? theme.palette.red[800] : theme.palette.neutralGrey[900]}`,
  fontStyle: 'normal',
  marginTop: 0,
  marginLeft: 18, // Component base width/2 (10px) + 8px gap
}))

export const StyledGroupHelperText = styled(FormHelperText)(({ theme, color }) => ({
  // Used in Radio3Group and Checkbox3Group
  color: `${color === 'error' ? theme.palette.red[800] : theme.palette.neutralGrey[900]}`,
  fontStyle: 'normal',
  marginTop: 0,
  marginLeft: -10, // Component base width/2 (10px)
}))

export const StyledHelperTextSwitch3 = styled(FormHelperText)<Switch3Props>(({ size, labelPlacement, theme }) => ({
  // Added font styles manually to fix build issue. Will fix this later
  ...(size === 'small' && { fontSize: '12px', lineHeight: '16px' }),
  ...((!size || size === 'medium') && { fontSize: '14px', lineHeight: '20px' }),
  letterSpacing: 0,
  fontWeight: 400,
  color: `${theme.palette.neutralGrey[900]}`,
  fontStyle: 'normal',
  marginTop: 0,
  marginLeft: labelPlacement === 'start' ? 0 : size === 'small' ? 25 : 33,
}))

export const StyledHelperTextSelect3 = styled(FormHelperText)(({ theme }) => ({
  color: `${theme.palette.neutralGrey[900]}`,
  fontStyle: 'normal',
  marginTop: 0,
  padding: '2px 0',
}))
